module.exports = __webpack_public_path__ + "static/media/report-big.a4731b5f.svg";